'use strict'

export default {
    // 测试地址
    ...{
        NODE_ENV: 'local',
        API_HOST: 'https://www.233xyx.com',
        QI_NIU_URL: 'https://test7niu.233xyx.com/',
        SAKURA_BASE_URL:'http://test-233admin.233duan.cn'
        // SAKURA_BASE_URL:'https://xiamen.233leyuan.com'
    },

    // // 预发地址
    // ...{
    //     NODE_ENV: 'pre',
    //     API_HOST: 'http://pre.233xyx.com', 
    // },

    // //
    // ...{
    //     API_HOST: 'https://www.233leyuan.com',
    // },

    //docker环境  勿删！！
    ...(process.env.NODE_ENV === "development" ? {} : window._API_HOST())
};
